export const parsePermissions = (permissionString) => {
  if (!permissionString) return [];
  return permissionString.split(",").map((p) => p.trim());
};

export const hasPermission = (permissionString, permission) => {
  const list = parsePermissions(permissionString);
  return list.includes(permission) || list.includes("modifyall");
};

export const hasAnyPermission = (permissionString, permissions) => {
  const list = parsePermissions(permissionString);
  return (
    list.includes("modifyall") ||
    permissions.some((permission) => list.includes(permission))
  );
};

export const hasAdminAccess = (user) => {
  if (!user) return false;
  if (typeof user.role_level !== "number" && user.role_level !== 0) return false;
  if (user.role_level > 4) return false;
  return hasAnyPermission(user.permission, ["read", "readall"]);
};
